import { render } from "./haircolorDiagProductTile.vue?vue&type=template&id=526a01fc"
import script from "./haircolorDiagProductTile.vue?vue&type=script&lang=js"
export * from "./haircolorDiagProductTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__